import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CatalogModel } from '../../../../data-layer/catalogs/types';
import { ProductItemModel } from '../../../../data-layer/posts/types';
import { useSearchAppMetricsAnalytics } from '../../../hooks/useSearchAppMetricsAnalytics';

export const useSearchAppAnalytics = ({
    catalog,
    products,
    showSiteButton,
}: {
    catalog?: CatalogModel;
    products: ProductItemModel[];
    showSiteButton: boolean;
}) => {
    const { trackProductShown, trackButtonShown } = useSearchAppMetricsAnalytics({
        source: 'business_catalog_page',
    });
    const [query] = useSearchParams();

    const [shownIds, setShownIds] = useState<string[]>([]);
    const [hasButtonShownLogged, setHasButtonShownLogged] = useState(false);

    const isFromSearchApp = query.get('morda_platform') === 'search_app';

    useEffect(() => {
        if (
            !isFromSearchApp ||
            hasButtonShownLogged ||
            !showSiteButton ||
            !catalog?.business?.siteUrl
        ) {
            return;
        }

        trackButtonShown('GoToSite', catalog.business.siteUrl);
        setHasButtonShownLogged(true);
    }, [catalog, hasButtonShownLogged, isFromSearchApp, showSiteButton, trackButtonShown]);

    useEffect(() => {
        if (!isFromSearchApp) {
            return;
        }

        const newItems = products.filter((p) => !shownIds.includes(p.id));

        newItems.forEach((p) => trackProductShown(p.id, p.url));

        if (newItems.length) {
            setShownIds((prev) => [...prev, ...newItems.map((p) => p.id)]);
        }
    }, [isFromSearchApp, products, shownIds, trackProductShown]);
};
